import styled from '@emotion/styled';
import { Layout, Menu } from 'antd';
import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { TaylorMadeLogo } from '../../../assets/index';
import { Role } from '../../../constants/define/role';
import { UserContext } from '../../../repository/context/userContext';
import { appStyles } from '../../../styles';

const { SubMenu } = Menu;

export interface MenuInfo {
  key: string;
  keyPath: string[];
  /** @deprecated This will not support in future. You should avoid to use this */
  item: React.ReactInstance;
  domEvent: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>;
}

export interface SelectInfo extends MenuInfo {
  selectedKeys: string[];
}

interface SiderProps {
  widthSider: number;
  menus: any[];
  onOpenChange: (openKeys: React.Key[]) => void;
  selectedKeys: string[];
  openKeys: string[];
  themeLayout: 'light' | 'dark';
  onSelect: (info: SelectInfo) => void;
  children: React.ReactNode;
}

const { Sider } = Layout;
const { ItemGroup, Item } = Menu;

export const SiderMenu = (props: SiderProps) => {
  const { openKeys, onOpenChange, selectedKeys, menus, themeLayout, widthSider, onSelect, children } = props;
  const userContext = useContext(UserContext);
  const generateMenus = (data: any, userContextGlobal: any) => {
    if (!userContextGlobal) {
      return null;
    }

    return data.map((itemGroup: any) => {
      if (
        [Role.ADMIN, Role.SUPER_ADMIN].includes(userContextGlobal?.user?.role) ||
        itemGroup?.roles?.includes(userContextGlobal.user?.role)
      ) {
        if (itemGroup.group) {
          return (
            <StyledItemGroup title={itemGroup.name} key={itemGroup.id}>
              {generateMenus(itemGroup.group, userContextGlobal)}
            </StyledItemGroup>
          );
        }
        if (itemGroup.children) {
          return (
            <SubMenu
              key={itemGroup.id}
              title={
                <>
                  {itemGroup.icon && itemGroup.icon}
                  <StyledSpan>{itemGroup.name}</StyledSpan>
                </>
              }
            >
              {generateMenus(itemGroup.children, userContextGlobal)}
            </SubMenu>
          );
        }

        return (
          <StyledItem key={itemGroup.id}>
            <NavLink to={itemGroup.route || '#'} style={itemGroup?.style} className="nav-link">
              {itemGroup.icon && itemGroup.icon}
              <StyledSpan>{itemGroup.name}</StyledSpan>
            </NavLink>
          </StyledItem>
        );
      }
      return null;
    });
  };

  return (
    <SiderStyled width={widthSider}>
      <img className="logo-tm" src={TaylorMadeLogo} alt="avatar-TM" />
      <Menu
        mode="inline"
        selectedKeys={selectedKeys}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        theme={themeLayout}
        onSelect={onSelect}
        style={menuStyle}
      >
        {generateMenus(menus, userContext)}
      </Menu>
      {children}
    </SiderStyled>
  );
};

const SiderStyled = styled(Sider)`
  min-height: 100vh;
  & > div > img.logo-tm {
    width: 40px;
    margin: 24px;
  }

  & > div > footer {
    ${appStyles.color.darkTheme}
    text-align: center;
    padding: 16px;
  }

  @media screen and (min-width: 1024px) {
    width: 260px;
  }

  @media screen and (max-width: 1024px) {
    width: 180px;
  }
`;

const StyledItemGroup = styled(ItemGroup)`
  & > div {
    padding-left: 1.5rem;
    margin-top: 1rem;
    font-weight: 600;
  }
  & .ant-menu-item-group-list {
    margin-left: 1rem;
  }
`;

const StyledItem = styled(Item)`
  & .nav-link {
    display: flex;
    align-items: center;
  }
  & > span > a {
    .anticon {
      font-size: 20px;
    }
  }
`;

const StyledSpan = styled.span`
  padding: 2px 0 2px 15px;
  margin-left: 0 !important;
`;

const menuStyle = {
  minHeight: 'calc(100% - 179px)',
};
